var _defs, _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingWentWrongImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.215,
    height: 109.601,
    viewBox: "0 0 101.215 109.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143138",
    "data-name": "Rectangle 143138",
    width: 63.915,
    height: 75.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143139",
    "data-name": "Rectangle 143139",
    width: 62.073,
    height: 73.747,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143140",
    "data-name": "Rectangle 143140",
    width: 56.817,
    height: 69.61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143141",
    "data-name": "Rectangle 143141",
    width: 29.752,
    height: 29.752,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40661",
    "data-name": "Group 40661",
    transform: "translate(-634.82 -288.482)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_60095",
    "data-name": "Path 60095",
    d: "M97.6,124.084a48.8,48.8,0,1,1-48.8-48.8,48.8,48.8,0,0,1,48.8,48.8",
    transform: "translate(634.82 216.302)",
    fill: "#dadde3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40651",
    "data-name": "Group 40651",
    transform: "translate(655.28 314.742)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40650",
    "data-name": "Group 40650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40649",
    "data-name": "Group 40649",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60096",
    "data-name": "Path 60096",
    d: "M557.966,642.82l-51.65-5.972a2.412,2.412,0,0,0-2.673,2.119L496.2,703.325A2.412,2.412,0,0,0,498.32,706l51.65,5.972a2.411,2.411,0,0,0,2.673-2.119l7.442-64.358a2.412,2.412,0,0,0-2.119-2.673",
    transform: "translate(-496.185 -636.831)",
    fill: "#3a7ec1"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60097",
    "data-name": "Path 60097",
    d: "M615.965,594.7l-51.65-5.972a2.412,2.412,0,0,0-2.673,2.119L554.2,655.2a2.412,2.412,0,0,0,2.119,2.673l51.65,5.972a2.412,2.412,0,0,0,2.673-2.119l7.442-64.359a2.412,2.412,0,0,0-2.119-2.673",
    transform: "translate(103.487 -275.954)",
    fill: "#dbe2ef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60098",
    "data-name": "Path 60098",
    d: "M593.019,649.31a3.125,3.125,0,0,1-.354-.02l-51.65-5.973a3.066,3.066,0,0,1-2.694-3.4l7.442-64.359a3.067,3.067,0,0,1,3.4-2.694l51.65,5.973a3.066,3.066,0,0,1,2.694,3.4L596.063,646.6a3.071,3.071,0,0,1-3.044,2.714m-44.213-75.155a1.758,1.758,0,0,0-1.742,1.555l-7.442,64.359a1.756,1.756,0,0,0,1.543,1.947l51.65,5.973a1.754,1.754,0,0,0,1.947-1.543l7.442-64.359a1.756,1.756,0,0,0-1.543-1.947l-51.65-5.973a1.768,1.768,0,0,0-.205-.012",
    transform: "translate(118.716 -260.744)",
    fill: "#7a89a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40654",
    "data-name": "Group 40654",
    transform: "translate(646.356 311.17)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40653",
    "data-name": "Group 40653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40652",
    "data-name": "Group 40652",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60099",
    "data-name": "Path 60099",
    d: "M333.774,550.207l-51.81,4.365a2.412,2.412,0,0,0-2.2,2.606l5.44,64.558a2.412,2.412,0,0,0,2.606,2.2l51.81-4.365a2.412,2.412,0,0,0,2.2-2.606l-5.44-64.558a2.411,2.411,0,0,0-2.606-2.2",
    transform: "translate(-279.754 -550.198)",
    fill: "#5e708d"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60100",
    "data-name": "Path 60100",
    d: "M382.981,488.4l-51.81,4.365a2.412,2.412,0,0,0-2.2,2.606l5.439,64.558a2.412,2.412,0,0,0,2.606,2.2l51.81-4.365a2.412,2.412,0,0,0,2.2-2.606l-5.44-64.558a2.411,2.411,0,0,0-2.606-2.2",
    transform: "translate(319.423 -179.767)",
    fill: "#e5e0cf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60101",
    "data-name": "Path 60101",
    d: "M321.586,547.585a3.071,3.071,0,0,1-3.054-2.809l-5.439-64.558a3.071,3.071,0,0,1,2.8-3.313l51.81-4.365a3.079,3.079,0,0,1,3.313,2.8l5.439,64.558a3.07,3.07,0,0,1-2.8,3.313l-51.81,4.366q-.13.011-.259.011m46.225-73.741L316,478.209a1.759,1.759,0,0,0-1.6,1.9l5.439,64.558a1.753,1.753,0,0,0,1.9,1.6l51.81-4.366a1.756,1.756,0,0,0,1.6-1.9l-5.439-64.559a1.758,1.758,0,0,0-1.9-1.6",
    transform: "translate(334.649 -164.562)",
    fill: "#7a89a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40657",
    "data-name": "Group 40657",
    transform: "translate(654.621 307.94)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40656",
    "data-name": "Group 40656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40655",
    "data-name": "Group 40655",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60102",
    "data-name": "Path 60102",
    d: "M534.6,471.875H482.607a2.412,2.412,0,0,0-2.412,2.412v64.787a2.412,2.412,0,0,0,2.412,2.411H534.6a2.412,2.412,0,0,0,2.412-2.411V474.287a2.412,2.412,0,0,0-2.412-2.412",
    transform: "translate(-480.195 -471.875)",
    fill: "#3a7ec1"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60103",
    "data-name": "Path 60103",
    d: "M587.635,488.455H535.641a2.412,2.412,0,0,1-2.412-2.412V421.257a2.412,2.412,0,0,1,2.412-2.412h51.994a2.412,2.412,0,0,1,2.411,2.412v64.787a2.411,2.411,0,0,1-2.411,2.412",
    transform: "translate(123.578 -113.092)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60104",
    "data-name": "Path 60104",
    d: "M572.415,473.89H520.421a3.07,3.07,0,0,1-3.066-3.066V406.036a3.07,3.07,0,0,1,3.066-3.066h51.994a3.07,3.07,0,0,1,3.066,3.066v64.787a3.07,3.07,0,0,1-3.066,3.066m-51.994-69.61a1.759,1.759,0,0,0-1.757,1.757v64.787a1.759,1.759,0,0,0,1.757,1.757h51.994a1.759,1.759,0,0,0,1.757-1.757V406.036a1.759,1.759,0,0,0-1.757-1.757Z",
    transform: "translate(138.798 -97.871)",
    fill: "#7a89a0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60105",
    "data-name": "Path 60105",
    d: "M715.64,709.624H693.479a1.373,1.373,0,0,1-1.369-1.369v-.114a1.373,1.373,0,0,1,1.369-1.369H715.64a1.373,1.373,0,0,1,1.369,1.369v.114a1.373,1.373,0,0,1-1.369,1.369",
    transform: "translate(-28.751 -389.147)",
    fill: "#e5e0cf"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60106",
    "data-name": "Path 60106",
    d: "M734.455,915.726H693.478a1.373,1.373,0,0,1-1.369-1.369v-.113a1.373,1.373,0,0,1,1.369-1.369h40.977a1.373,1.373,0,0,1,1.369,1.369v.113a1.373,1.373,0,0,1-1.369,1.369",
    transform: "translate(-28.75 -586.751)",
    fill: "#e8eaee"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60107",
    "data-name": "Path 60107",
    d: "M734.455,1138.1H693.478a1.373,1.373,0,0,1-1.369-1.369v-.113a1.373,1.373,0,0,1,1.369-1.369h40.977a1.373,1.373,0,0,1,1.369,1.369v.113a1.373,1.373,0,0,1-1.369,1.369",
    transform: "translate(-28.75 -799.953)",
    fill: "#e8eaee"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60108",
    "data-name": "Path 60108",
    d: "M734.455,1360.471H693.478a1.373,1.373,0,0,1-1.369-1.369v-.113a1.373,1.373,0,0,1,1.369-1.369h40.977a1.373,1.373,0,0,1,1.369,1.369v.113a1.373,1.373,0,0,1-1.369,1.369",
    transform: "translate(-28.75 -1013.157)",
    fill: "#e8eaee"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60109",
    "data-name": "Path 60109",
    d: "M734.455,1582.843H693.478a1.373,1.373,0,0,1-1.369-1.369v-.113a1.373,1.373,0,0,1,1.369-1.369h40.977a1.373,1.373,0,0,1,1.369,1.369v.113a1.373,1.373,0,0,1-1.369,1.369",
    transform: "translate(-28.75 -1226.36)",
    fill: "#e8eaee"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60110",
    "data-name": "Path 60110",
    d: "M734.455,1798.437H693.478a1.373,1.373,0,0,1-1.369-1.369v-.114a1.373,1.373,0,0,1,1.369-1.369h40.977a1.373,1.373,0,0,1,1.369,1.369v.114a1.373,1.373,0,0,1-1.369,1.369",
    transform: "translate(-28.75 -1433.063)",
    fill: "#e8eaee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40660",
    "data-name": "Group 40660",
    transform: "translate(705.046 324.651)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40659",
    "data-name": "Group 40659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40658",
    "data-name": "Group 40658",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60111",
    "data-name": "Path 60111",
    d: "M1717.98,877.156a14.876,14.876,0,1,0,14.876,14.876,14.893,14.893,0,0,0-14.876-14.876",
    transform: "translate(-1703.104 -877.156)",
    fill: "#5e708d"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60112",
    "data-name": "Path 60112",
    d: "M1777.42,857.852a14.221,14.221,0,1,1-14.221-14.221,14.221,14.221,0,0,1,14.221,14.221",
    transform: "translate(-1042.039 -520.362)",
    fill: "#d3c383"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60113",
    "data-name": "Path 60113",
    d: "M1747.975,857.51a14.876,14.876,0,1,1,14.876-14.876,14.893,14.893,0,0,1-14.876,14.876m0-28.443a13.567,13.567,0,1,0,13.566,13.566,13.582,13.582,0,0,0-13.566-13.566",
    transform: "translate(-1026.816 -505.144)",
    fill: "#7a89a0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60114",
    "data-name": "Path 60114",
    d: "M2032.681,980.625h0a1.5,1.5,0,0,1-1.582-1.144l-1.023-9.357c-.219-2.007.937-3.919,2.6-3.919s2.824,1.912,2.6,3.919l-1.023,9.357a1.5,1.5,0,0,1-1.582,1.144",
    transform: "translate(-1311.521 -637.883)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60115",
    "data-name": "Path 60115",
    d: "M2053.02,1346.673c0,.746-.822,1.351-1.836,1.351s-1.836-.6-1.836-1.351.822-1.351,1.836-1.351,1.836.6,1.836,1.351",
    transform: "translate(-1330.025 -1001.366)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60116",
    "data-name": "Path 60116",
    d: "M485.109,3.1A3.1,3.1,0,1,1,482,0a3.1,3.1,0,0,1,3.1,3.1",
    transform: "translate(175.667 288.482)",
    fill: "#e5e0cf"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60117",
    "data-name": "Path 60117",
    d: "M2078.105,467.036a3.577,3.577,0,1,1-3.576-3.577,3.576,3.576,0,0,1,3.576,3.577",
    transform: "translate(-1350.738 -155.866)",
    fill: "#5e708d",
    opacity: 0.16
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60118",
    "data-name": "Path 60118",
    d: "M1278.365,2488.1a3.577,3.577,0,1,1-3.577-3.577,3.577,3.577,0,0,1,3.577,3.577",
    transform: "translate(-583.975 -2093.593)",
    fill: "#e5e0cf"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60119",
    "data-name": "Path 60119",
    d: "M117.74,1542.1a1.923,1.923,0,1,1-1.582-2.213,1.924,1.924,0,0,1,1.582,2.213",
    transform: "translate(525.599 -1187.881)",
    fill: "#5e708d",
    opacity: 0.16
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143142",
    "data-name": "Rectangle 143142",
    width: 101.215,
    height: 109.601,
    transform: "translate(634.82 288.482)",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143143",
    "data-name": "Rectangle 143143",
    width: 101.215,
    height: 109.601,
    transform: "translate(634.82 288.482)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrongImg);
export default __webpack_public_path__ + "static/media/SomethingWentWrongImg.00886020e18577efc67844aeb25ad986.svg";
export { ForwardRef as ReactComponent };